export var stesp = [
    {
        id:29,
        img:require("../../Images/Stethoscope1.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"350 EGP"
    },
    {
        id:30,
        img:require("../../Images/Stethoscope2.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"450 EGP"
    },
    {
        id:31,
        img:require("../../Images/Stethoscope3.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"250 EGP"
    },
    {
        id:32,
        img:require("../../Images/Stethoscope4.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"2500"
    },
    {
        id:33,
        img:require("../../Images/Stethoscope5.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1500"
    },
    {
        id:34,
        img:require("../../Images/Stethoscope6.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1300"
    },
    {
        id:35,
        img:require("../../Images/Stethoscope7.avif"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"900"
    },
    {
        id:36,
        img:require("../../Images/Stethoscope8.webp"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1200"
    },
    {
        id:37,
        img:require("../../Images/Stethoscope9.webp"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1250"
    },
    {
        id:38,
        img:require("../../Images/Stethoscope10.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1400"
    },
    {
        id:39,
        img:require("../../Images/Stethoscope11.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1350"
    },
    {
        id:40,
        img:require("../../Images/Stethoscope12.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1550"
    },
    {
        id:41,
        img:require("../../Images/Stethoscope13.jpg"),
        title:"Stethoscope",
        description:"Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus, similique earum.",
        price:"1450"
    },


]